import React from "react"
import { getSvgFill } from "utils"

const LightlyActive = ({ isSelected = false }: { isSelected?: boolean }) => {
  const { pathFill } = getSvgFill(isSelected)
  const fillOpacity = isSelected ? 1 : 0.6
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <path
        d="M17 9.09375C18.5188 9.09375 19.75 7.86253 19.75 6.34375C19.75 4.82497 18.5188 3.59375 17 3.59375C15.4812 3.59375 14.25 4.82497 14.25 6.34375C14.25 7.86253 15.4812 9.09375 17 9.09375Z"
        fill={pathFill}
        fillOpacity={fillOpacity}
      />
      <path
        d="M26.625 16.8625C26.625 16.1888 26.13 15.6388 25.47 15.5288C23.7512 15.24 22.1288 14.3188 21.0288 13.1088L19.255 11.1425C19.0213 10.8813 18.7325 10.675 18.4162 10.5238C18.4025 10.5238 18.4025 10.51 18.3888 10.51H18.375C17.8663 10.2213 17.3025 10.0838 16.6562 10.1663C15.2538 10.3313 14.25 11.5963 14.25 13.0125V21.125C14.25 22.6375 15.4875 23.875 17 23.875H23.875V29.375C23.875 30.1313 24.4937 30.75 25.25 30.75C26.0063 30.75 26.625 30.1313 26.625 29.375V23.1875C26.625 21.675 25.3875 20.4375 23.875 20.4375H19.75V15.6938C21.125 16.835 23.05 17.8113 24.975 18.1963C25.8275 18.375 26.625 17.7288 26.625 16.8625Z"
        fill={pathFill}
        fillOpacity={fillOpacity}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1562 10.125C11.9156 10.125 12.5312 10.7406 12.5312 11.5V21.8125C12.5312 23.9008 14.2242 25.5938 16.3125 25.5938H21.125C21.8844 25.5938 22.5 26.2094 22.5 26.9688C22.5 27.7281 21.8844 28.3438 21.125 28.3438H16.3125C12.7054 28.3438 9.78125 25.4196 9.78125 21.8125V11.5C9.78125 10.7406 10.3969 10.125 11.1562 10.125Z"
        fill={pathFill}
        fillOpacity={fillOpacity}
      />
    </svg>
  )
}

export default LightlyActive
